module.exports = __webpack_public_path__ + "d10.no2.70ba6df6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d10.no2.jpg
// module id = sqbK
// module chunks = 0